import { MainCard, MainCardContent, MainCardTitle } from "src/components/main-card-type.tsx"
import { useEffect, useState } from "react";
import { useIsVerified } from "src/components/email-verification";
import {
  checkCalculatorUsageLimitAndRedirect,
  loadSavedCalculatorData,
  removeMask,
  sanitizeBrlValue,
  saveCalculatorData,
} from "src/utils/functions";
import { Button } from "src/components/ui/button";
import { Vis_PraResponse } from "../Vista-Prazo.d";

export const VistaPrazoInputCard = ({
  setResults,
}: {
  setResults: (value: Vis_PraResponse | null) => void
}) => {
  const calculatorKey = "vista-prazo";
  const isVerified = useIsVerified();
  const [message, setMessage] = useState<string>("");

  const [valorPago, setValorPago] = useState("")
  const [pagamentoVista, setPagamentoVista] = useState("")
  const [parcela, setParcela] = useState("")
  const [guardar, setGuardar] = useState("")
  const [informarDesconto, setInformarDeconto] = useState(false)
  const [desconto, setDesconto] = useState("")
  const [travar, setTravar] = useState(false)
  const [personalizar, setPersonalizar] = useState(false)
  const [redimentoAno, setRedimentoAno] = useState("")

  useEffect(() => {
    if (guardar === "personalizar") {
      setPersonalizar(true);
    } else {
      setPersonalizar(false);
    }
  }, [guardar]);
  function handleSave() {
    saveCalculatorData(calculatorKey, {
      valorPago,
      pagamentoVista,
      parcela,
      guardar,
      informarDesconto,
      desconto,
      travar,
    })
  }

  function clear() {
    setValorPago("");
    setPagamentoVista("");
    setParcela("");
    setGuardar("nao")
    setInformarDeconto(false);
    setDesconto("");
    setTravar(false)
  }
  useEffect(() => {
    const savedData = loadSavedCalculatorData(calculatorKey);
    if (!savedData) return;
    setValorPago((savedData.valorPago as string) || "");
    setPagamentoVista((savedData.pagamentoVista as string) || "");
    setParcela((savedData.parcela as string) || "")
    setGuardar((savedData.guardar as string) || "")
    setInformarDeconto((savedData.informarDesconto as boolean) || false)
    setDesconto((savedData.desconto as string) || "")
    setTravar((savedData.travar as boolean) || false)
  }, []);

  function handleDesconto() {
    setInformarDeconto(!informarDesconto)
    setTravar(true)
    setPagamentoVista("")
    if (informarDesconto === true) {
      setDesconto("")
      setTravar(false)
    }
  }



  function calcular() {
    console.log(pagamentoVista);

    if (!valorPago) {
      setMessage("Adcione um valor ao Produto")
      setResults(null)
      return
    }
    if (!parcela || parcela === "0") {
      setMessage("Adicione um numero de parcelas")
      setResults(null)
      return
    }
    if (!pagamentoVista && !desconto) {
      setMessage("Adcione um valor no Pagamento à vista ou uma porcentagem de desconto")
      setResults(null)
      return

    }


    const Produto = removeMask(valorPago);

    const ValorVista = removeMask(pagamentoVista)

    const numeroParcela: number = removeMask(parcela)

    let ValorDesconto = removeMask(desconto)

    let ValorRedimento = removeMask(redimentoAno)

    if (Produto <= ValorVista) {
      setMessage("Valor de Entrada não pode ser igual ou maior que o Produto")
      setResults(null)
      return
    }
    setMessage("")

    let descontoPorcentagem: number = ValorDesconto
    let taxaCDI: number = 0;
    let resultType: string = "Prazo"
    let vistaFinal: number = 0
    let prazoFinal: number = 0
    let resultValor: number = 0
    const taxaCDIAnual = 0.1490;
    let taxamensalCDI = (1 + taxaCDIAnual) ** (1 / 12) - 1;

    switch (guardar) {
      case "nao":
        taxaCDI = 0;
        break;
      case "CDB80%":
        taxaCDI = taxamensalCDI * 0.8;
        break;
      case "CDB100%":
        taxaCDI = taxamensalCDI * 1.0;
        break;
      case "CDB120%":
        taxaCDI = taxamensalCDI * 1.2;
        break;
      case "poupança":
        taxaCDI = 0.005;
        break;
      case "tesouro":
        taxaCDI = 0.0125;
        break;
      case "personalizar":
        taxaCDI = taxamensalCDI * ValorRedimento;
        break;
      default:
        taxaCDI = taxamensalCDI;
    }

    let mes = 1
    let restoInvestir: number = Produto - ValorVista
    let valorEntrada = ValorVista
    let resultadoInvestido = restoInvestir * taxaCDI
    let fluxoMensal: { mes: number, valorParcela: number; valorInvestido: number, resultadoInvestido: number; valorParaInvestir: number; }[] = []
    let fluxoSemInvestir: { mes: number, valorSemInvestir: number, resultSemInvestir: number }[] = []
    let valorParcela = restoInvestir / numeroParcela

    fluxoMensal.push({
      mes: 0,
      valorParcela: valorEntrada,
      valorInvestido: restoInvestir,
      resultadoInvestido: 0,
      valorParaInvestir: restoInvestir
    })
    let inflacao = 0.00392;
    let valorInvestido = restoInvestir - valorParcela
    let valorParaInvestir = valorInvestido + resultadoInvestido
    let resultSemInvestir = 0
    let valorSemInvestir = restoInvestir
    resultSemInvestir = valorSemInvestir * inflacao
    valorSemInvestir -= resultSemInvestir
    valorSemInvestir -= valorParcela
    let totalSemInvestir = resultSemInvestir


    fluxoSemInvestir.push({
      mes: 0,
      valorSemInvestir: restoInvestir,
      resultSemInvestir: 0

    })
    for (mes; mes <= numeroParcela; mes++) {

      console.log(resultSemInvestir);
      fluxoSemInvestir.push({
        mes: mes,
        valorSemInvestir: valorSemInvestir,
        resultSemInvestir: resultSemInvestir
      })
      resultSemInvestir = Math.round((valorSemInvestir * inflacao) * 100) / 100
      valorSemInvestir -= valorParcela
      valorSemInvestir -= resultSemInvestir


      fluxoMensal.push({
        mes: mes,
        valorParcela: Math.round(valorParcela * 100) / 100,
        valorInvestido: Math.round(valorInvestido * 100) / 100,
        resultadoInvestido: Math.round(resultadoInvestido * 100) / 100,
        valorParaInvestir: Math.round(valorParaInvestir * 100) / 100
      })
      valorInvestido = valorInvestido + resultadoInvestido - valorParcela
      resultadoInvestido = valorParaInvestir * taxaCDI
      valorParaInvestir = valorInvestido + resultadoInvestido


    }

    vistaFinal = Produto
    if (ValorDesconto >= 0) {
      resultType = "Vista"
      ValorDesconto = ValorDesconto / 100
      vistaFinal = Produto * ValorDesconto
      vistaFinal = Produto - vistaFinal
    }
    prazoFinal = Produto

    switch (resultType) {
      case "Vista":
        prazoFinal = 0
        break
      case "Prazo":
        vistaFinal = 0
    }

    const results = {
      vistaFinal: vistaFinal,
      prazoFinal: prazoFinal,
      resultValor: resultValor,
      resultType: resultType,
      numeroParcela: numeroParcela,
      fluxoMensal: fluxoMensal,
      fluxoSemInvestir: fluxoSemInvestir,
      restoInvestir: restoInvestir,
      produto: Produto,
      valorDesconto: descontoPorcentagem,
      totalSemInvestir: totalSemInvestir
    }

    setResults(results)

  }
  return (
    <MainCard>
      <MainCardTitle>
        À vista ou a Prazo
      </MainCardTitle>
      <form action=""
        onSubmit={(e) => {
          e.preventDefault();
          handleSave();
          checkCalculatorUsageLimitAndRedirect(calcular)
        }}>
        <MainCardContent>
          <div>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Valor da compra *
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={valorPago}
                onChange={(event) => setValorPago(sanitizeBrlValue(event))}
              />
            </div>
          </div>
          <div>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Valor Entrada
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                R$
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="00,00"
                type="text"
                value={pagamentoVista}
                disabled={travar}
                onChange={(event) => setPagamentoVista(sanitizeBrlValue(event))}
              />
            </div>
          </div>
          <div>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Numero de parcelas
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                N°
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="0"
                type="text"
                value={parcela}
                onChange={(event) => setParcela(event.target.value)}
              />
            </div>
          </div>
          <div>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Onde você guarda seu dinheiro para render?
            </label>
            <div className="flex border">
              <select name="" value={guardar} onChange={(event) => setGuardar(event.target.value)}
                id="guardar" className="flex-1 p-2 min-w-[100px]"
              >
                <option value="nao">Não aplico meu dinheiro</option>
                <option value="poupança">Poupança</option>
                <option value="tesouro">Tesouro Selic (LFT)</option>
                <option value="CDB80%">CDB de um banco grande (80% CDI)</option>
                <option value="CDB100%">CDB de um banco médio (100% CDI)</option>
                <option value="personalizar">Personalizar</option>
              </select>
            </div>
          </div>
          <div className={`${personalizar ? "block" : "hidden"}`}>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Redimento ao ano
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                %
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="0%"
                type="text"
                value={redimentoAno}
                onChange={(event) => setRedimentoAno(event.target.value)}
              />
            </div>
          </div>
          <div>
            <input type="checkbox" id="desconto" checked={informarDesconto} onChange={handleDesconto} />
            <label className="pl-2" htmlFor="desconto">Informar desconto (%)</label>
          </div>
          <div className={`${informarDesconto ? "block" : "hidden"}`}>
            <label className="block mb-2 font-medium text-sm" htmlFor="bruto-id">
              Desconto (%)
            </label>
            <div className="flex border">
              <span className="inline-flex items-center px-3 border-r text-sm bg-[#e9ecef]">
                %
              </span>
              <input
                className="flex-1 p-2 min-w-[100px]"
                id="bruto-id"
                placeholder="0%"
                type="text"
                value={desconto}
                onChange={(event) => setDesconto(event.target.value)}

              />
            </div>
          </div>
        </MainCardContent>
        <div className="flex justify-between">
          <Button
            disabled={!isVerified}
            type="submit"
            variant={"default"}
            className="sm:w-[150px]"
          >
            Calcular
          </Button>

          <div className="flex flex-col sm:flex-row items-center gap-2">

            <Button onClick={clear} type="button" variant={"ghost"}>
              Limpar
            </Button>
          </div>
        </div>
      </form>
      <p className="text-red-800 text-center mt-2 font-bold">{message}</p>

    </MainCard >
  )
}